import type { SupportedLocale } from '../types';

const RTL_LOCALES = new Set<SupportedLocale>(['ar']);

export type Direction = 'ltr' | 'rtl';

export function directionFor(locale: SupportedLocale): Direction {
  return RTL_LOCALES.has(locale) ? 'rtl' : 'ltr';
}

export function isRtl(locale: SupportedLocale): boolean {
  return directionFor(locale) === 'rtl';
}

/** Apply `dir` and `lang` to the root document. SSR-safe (no-op on server). */
export function syncDocumentDirection(locale: SupportedLocale): void {
  if (typeof document === 'undefined') return;
  const dir = directionFor(locale);
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', locale);
}
